export const ONE_HOUR_IN_MINUTES = 60
export const ONE_MINUTE_IN_SECONDS = ONE_HOUR_IN_MINUTES
export const ONE_DAY_IN_HOURS = 24
export const ONE_WEEK_IN_DAYS = 7
export const ONE_MONTH_IN_DAYS = 30
export const ONE_YEAR_IN_DAYS = 365
export const ONE_SECOND = 1000
export const ONE_MINUTE = ONE_SECOND * ONE_MINUTE_IN_SECONDS
export const ONE_HOUR = ONE_MINUTE * ONE_HOUR_IN_MINUTES
export const ONE_DAY = ONE_HOUR * ONE_DAY_IN_HOURS
export const ONE_WEEK = ONE_DAY * ONE_WEEK_IN_DAYS
export const ONE_MONTH = ONE_DAY * ONE_MONTH_IN_DAYS
export const ONE_YEAR = ONE_DAY * ONE_YEAR_IN_DAYS
